(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanjeevani-cro-content"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sj-final-cart')) {
customElements.define('sj-final-cart', class extends HTMLElement {
connectedCallback(){
this.button=this.querySelector('button');
this.main=document.querySelector('.sj-cro-product');
if(!this.main)return;
this.sync=()=>{
const source=this.main.querySelector('product-form-component button[type="submit"]');
if(!source)return;
this.button.disabled=source.disabled;
this.button.textContent=source.disabled?source.textContent.trim():this.button.dataset.label;
const price=this.main.querySelector('product-price .price');
const output=this.closest('section').querySelector('[data-sj-price]');
if(price&&output)output.textContent=price.textContent.trim();
};
this.add=()=>{const source=this.main.querySelector('product-form-component button[type="submit"]');if(source&&!source.disabled)source.click();};
this.button.addEventListener('click',this.add);
this.observer=new MutationObserver(this.sync);
this.observer.observe(this.main,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
this.sync();
}
disconnectedCallback(){this.observer?.disconnect();this.button?.removeEventListener('click',this.add);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanjeevani-cro-product"]) return;
  try {
    
if(!customElements.get('sj-cro-sticky')){
customElements.define('sj-cro-sticky',class extends HTMLElement{
connectedCallback(){
this.root=this.closest('.sj-cro-product');
this.bar=this.querySelector('[ref="stickyBar"]');
this.button=this.querySelector('[data-sj-sticky-button]');
this.source=()=>this.root.querySelector('product-form-component button[type="submit"]');
this.update=()=>{
const source=this.source();if(!source)return;
const rect=source.getBoundingClientRect();
const footer=document.querySelector('footer')||document.querySelector('[class*="footer-group"]');
const nearFooter=footer&&footer.getBoundingClientRect().top<innerHeight;
this.bar.dataset.stuck=String(rect.bottom<0&&!nearFooter&&!source.disabled);
this.button.disabled=source.disabled;
const qty=this.root.querySelector('input[name="quantity"]')?.value||'1';
this.querySelector('[ref="quantityNumber"]').textContent=qty;
this.querySelector('[ref="quantityDisplay"]').style.display=Number(qty)>1?'inline':'none';
};
this.click=()=>{const source=this.source();if(source&&!source.disabled)source.click();};
this.button.addEventListener('click',this.click);
this.scroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=null;this.update();});};
addEventListener('scroll',this.scroll,{passive:true});
addEventListener('resize',this.scroll);
this.observer=new MutationObserver(this.scroll);
this.observer.observe(this.root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
this.update();
}
disconnectedCallback(){removeEventListener('scroll',this.scroll);removeEventListener('resize',this.scroll);this.observer?.disconnect();this.button?.removeEventListener('click',this.click);cancelAnimationFrame(this.frame);}
});
}

  } catch(e) { console.error(e); }
})();
})();
